import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setArchived, setComplianceFilter, setHvaStatusFilter } from "../store/filtersSlice";
import { LocationFilter } from "./location_filter";
import { GlgSelect } from "../../shared/components";

export const COMPLIANCE_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Manually Added', value: 'manually-added' },
  { label: 'Compliant', value: 'compliant' },
  { label: 'Partially Compliant', value: 'semi-compliant' },
  { label: 'Non-Compliant', value: 'non-compliant' }
];

export const HVA_STATUS_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Expired', value: 'expired' },
  { label: 'Compliant', value: 'compliant' }
];

export const CourseDetailedFilters = ({show}) => {
  const [compliance, setCompliance] = useState('all')
  const [hvaStatus, setHvaStatus] = useState('all')

  const dispatch = useDispatch()
  const archivedFilter = useSelector((state) => state?.filters?.archived)
  const usesHva = useSelector((state) => state?.misc?.data?.usesHva)
  const [showArchived, setShowArchived] = useState(archivedFilter)
  const MRLeague = useSelector((state) => state.misc.data.MRLeague)

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setComplianceFilter(compliance))
    }, 500)
    return () => clearTimeout(timer)
  }, [compliance])

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setHvaStatusFilter(hvaStatus))
    }, 500)
    return () => clearTimeout(timer)
  }, [hvaStatus])

  const handleToggleArchived = (newArchived) => {
    setShowArchived(newArchived)
    dispatch(setArchived(newArchived))
  }

  if(!show)
    return null

  return (
    <>
    <Row>
      <Col md={6}>
        <Row className="courses-dropdown-container">
          <Col md={4}>
            <LocationFilter/>
          </Col>
          { !gon.uses_non_whs_terminology &&
            <Col md={4}>
              <div className="bold">{window.I18n.t('courses.compliance_status')}</div>
              <GlgSelect
                className='courses-filter-dropdown'
                items={COMPLIANCE_OPTIONS}
                height={33}
                onChange={(compliance) => setCompliance(compliance)}
                value={compliance}/>
            </Col>
          }
          { usesHva && 
            <Col md={4}>
              <div className="bold">{window.I18n.t('courses.hva_filtering')}</div>
              <GlgSelect
                className='courses-filter-dropdown'
                items={HVA_STATUS_OPTIONS}
                height={33}
                onChange={(status) => setHvaStatus(status)}/>
            </Col>
          }
        </Row>
      </Col>
      { MRLeague &&
        <Col md={6} className="courses-dropdown-container">
          <div className="courses-radio-container">
            <div>
              <label className={`icheck-label chip ${!showArchived ? 'chip-checked' : ''}`}>
                <div className={`icheckbox_square-orange icheck-item icheck ${!showArchived ? 'checked' : ''}`}>
                  <input
                    type='checkbox'
                    name='archived'
                    className='icheck-input'
                    checked={!showArchived}
                    onChange={() => handleToggleArchived(false)}
                  />
                </div>
                <span>{window.I18n.t('courses.active_courses')}</span>
              </label>
            </div>

            <div className="pull-right">
              <label className={`icheck-label chip ${showArchived ? 'chip-checked' : ''}`}>
                <div className={`icheckbox_square-orange icheck-item icheck ${showArchived ? 'checked' : ''}`}>
                  <input
                    type='checkbox'
                    name='archived'
                    className='icheck-input'
                    checked={showArchived}
                    onChange={() => handleToggleArchived(true)}
                  />
                </div>
                <span>{window.I18n.t('courses.archived_courses')}</span>
              </label>
            </div>
          </div>
        </Col>
      }
    </Row>
    </>
  )
}